export default __webpack_public_path__ + "static/media/paymentSpinner.46b26bcc.gif";